import { PreferenceText as PreferenceTextBase } from '@codesandbox/common/lib/components/Preference/PreferenceText';
import styled from 'styled-components';

export const PreferenceText = styled(PreferenceTextBase)`
  font-family: 'Source Code Pro';
  font-size: 0.8rem;
  width: 100%;
`;
